import Api from '../../../helpers/Api';

// ACTION  TYPE
export const SET_TOP_SONGS = 'SET_TOP_SONGS';
const setListTopSongs = (artist, listTopSongs) => ({
    type: SET_TOP_SONGS,
    artist,
    listTopSongs,
});

export const IS_PLAY_TOP_SONG = 'IS_PLAY_TOP_SONG';
const setIsPlayTopSong = (previewTopSong) => ({
    type: IS_PLAY_TOP_SONG,
    previewTopSong,
});

export const IS_PAUSE_TOP_SONG = 'IS_PAUSE_TOP_SONG';
const setIsPauseTopSong = () => ({
    type: IS_PAUSE_TOP_SONG,
});

export const SET_IS_LOADING_TOP_SONGS = 'SET_IS_LOADING_TOP_SONGS';
const setIsLoading = (status) => ({
    type: SET_IS_LOADING_TOP_SONGS,
    status,
});

export const RESET_TOP_SONGS = 'RESET_TOP_SONGS';
const resetTopSongs = () => ({
    type: RESET_TOP_SONGS,
});

// ACTION

export const fetchArtistTopSongsIfNeeded = (artistSlug, limit = 3) => (dispatch, getState) => {
    const currentArtist = getState().artists.ArtistTopSongs.artist;

    if (currentArtist !== artistSlug) {
        dispatch(setIsLoading(true));

        const query = `api/v1/artists/getArtistsTopSongs/${artistSlug}/${limit}`;

        return Api.get(query)
            .then((json) => {
                if (json.status === 'success') {
                    dispatch(setIsLoading(false));

                    return dispatch(setListTopSongs(artistSlug, json.data));
                }

                dispatch(resetTopSongs());

                throw `error from server: ${json.message}`;
            }).catch((error) => {
                dispatch(setIsLoading(false));

                // eslint-disable-next-line no-console
                console.log('fetchArtistTopSongsIfNeeded got error:', error);

                return dispatch(resetTopSongs());
            });
    }

    return Promise.resolve(1);
};


export const playTopSong = (previewTopSong) => (dispatch) => {
    dispatch(setIsPlayTopSong(previewTopSong));
};


export const pauseTopSong = () => (dispatch) => {
    dispatch(setIsPauseTopSong());
};
